export default {
	props:{
	},
	data(){
		return {}
	},
	watch: {},
	computed: {},
	methods: {
		onMouseMove(e){
			let ttc = this.$refs.simpleToolTipContent;
			ttc.style.left = (e.clientX + ttc.clientWidth + 10 < document.body.clientWidth) ? (e.clientX + 10 + "px") : (document.body.clientWidth - 5 - ttc.clientWidth + "px");
			ttc.style.top = (e.clientY + ttc.clientHeight + 10 < document.body.clientHeight) ? (e.clientY + 10 + "px") : (document.body.clientHeight - 5 - ttc.clientHeight + "px");
		},
	},
	template: `
<div ref="simpleToolTip" class="simple-tooltip" @mousemove="onMouseMove">
	<slot name="activator">activator</slot>
	<div ref="simpleToolTipContent" class="simple-tooltip-content" style="position:fixed;"><slot>content</slot></div>
</div>
`,
}
